import React, { useState, useRef, useEffect } from "react";
import { fetchAnnotation, saveAnnotation } from "./annotationPanel.api";

interface AnnotationPanelProps {
  wine: string;
  tab: string;
  lang: string;
}

export function AnnotationPanel({ wine, tab, lang }: AnnotationPanelProps) {
  const [note, setNote] = useState("");
  const [saved, setSaved] = useState(false);
  const [open, setOpen] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!wine || !tab || !lang) return;
    fetchAnnotation(wine, tab, lang).then(setNote).catch(() => setNote(""));
  }, [wine, tab, lang]);

  const onChange = (v: string) => {
    setNote(v);
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      await saveAnnotation(wine, tab, lang, v);
      setSaved(true);
      setTimeout(() => setSaved(false), 1800);
    }, 700);
  };

  return (
    <div className="border-t border-foreground/5">
      <button
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="w-full px-4.5 py-3 min-h-touch flex justify-between items-center bg-transparent border-none cursor-pointer font-sans"
      >
        <div className="flex items-center gap-2">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 3.5h8M2 6h6M2 8.5h4" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" className={note ? "text-accent" : "text-secondary"} />
          </svg>
          <span className={`text-base ${note ? "text-accent" : "text-secondary"}`}>Notes caviste{note ? " · enregistré" : ""}</span>
        </div>
        <span className="text-base text-secondary opacity-50">{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="px-4.5 pb-4">
          <textarea
            defaultValue={note}
            onChange={(e) => onChange(e.target.value)}
            rows={3}
            placeholder="Corrections, spécificités maison…"
            className={`input resize-y leading-[1.7] ${note ? "border-accent-border" : ""}`}
          />
          <div className="flex justify-between mt-1.5">
            <span className="text-[12px] text-secondary opacity-50 italic">Sauvegardé sur le serveur</span>
            {saved && <span className="text-[12px] text-success">✓ Sauvegardé</span>}
          </div>
        </div>
      )}
    </div>
  );
}
